import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import HomePage from './HomePage';
import PrivacyPolicy from './PrivacyPolicy';

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

function App() {
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1211640675192195";
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);
  
    // รอให้สคริปต์โหลดเสร็จก่อนเรียก adsbygoogle.push({})
    script.onload = () => {
      if (window.adsbygoogle) {
        window.adsbygoogle.push({});
      }
    };
  }, []); // ใช้ [] เพื่อให้โหลดเพียงครั้งเดียว

  return (
    <Router>
      <div className="min-h-screen" style={{ backgroundColor: '#f6f7f7' }}>
        {/* Hero Banner */}
        <div 
          className="w-full h-[100px] bg-cover bg-center bg-no-repeat mb-8"
          style={{
            backgroundImage: 'url("/images/banner-hero.png")',
            height: '100px',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        ></div>

        {/* AdSense Component */}
        <div className="flex justify-center my-4">
          <ins className="adsbygoogle"
            style={{ display: "block" }}
            data-ad-client="ca-pub-1211640675192195"
            data-ad-slot="9841845359"
            data-ad-format="auto"
            data-full-width-responsive="true">
          </ins>
        </div>

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>

        {/* Footer */}
        <footer className="py-6 text-center text-gray-500 text-sm">
          Copyright © 2025. All rights reserved.
          <br />
          <Link to="/privacy-policy" className="text-blue-500 hover:underline">
            นโยบายความเป็นส่วนตัว
          </Link>
        </footer>
      </div>
    </Router>
  );
}

export default App;
